import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '@/lib/api';
import { AlertCircle } from 'lucide-react';
import AurocleLogo from '@/components/landing/AurocleLogo';

export default function AdminLogin() {
  const [name, setName] = useState('');
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!name || !pin) return;
    setLoading(true);
    setError('');
    try {
      const res = await api.adminLogin({ name, pin });
      localStorage.setItem('aurocle_admin_token', res.data.token);
      localStorage.setItem('aurocle_admin_name', res.data.name);
      navigate('/admin/dashboard');
    } catch {
      setError('Invalid credentials');
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-aurocle-base flex items-center justify-center px-6" data-testid="admin-login-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <AurocleLogo size={48} className="mx-auto mb-6" />
          <div className="font-heading text-lg tracking-[0.15em] uppercase text-aurocle-text font-medium mb-2">
            Aurocle <span className="text-aurocle-gold">Command</span>
          </div>
          <p className="text-xs text-aurocle-text-secondary">Internal Operations Console</p>
        </div>

        <form onSubmit={handleLogin} className="glass-card p-8 space-y-5">
          <div>
            <label className="premium-label">Name</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="premium-input"
              placeholder="Your name" data-testid="admin-login-name" autoFocus />
          </div>
          <div>
            <label className="premium-label">PIN Code</label>
            <input type="password" value={pin} onChange={(e) => setPin(e.target.value)} className="premium-input"
              placeholder="Enter PIN" data-testid="admin-login-pin" />
          </div>

          {error && (
            <div className="flex items-center gap-2 text-red-400 text-sm" data-testid="admin-login-error">
              <AlertCircle size={14} /> {error}
            </div>
          )}

          <button type="submit" disabled={loading} className="btn-gold w-full" data-testid="admin-login-submit">
            {loading ? 'Authenticating...' : 'Access Command Center'}
          </button>
        </form>

        <div className="text-center mt-6">
          <a href="/" className="text-xs text-aurocle-text-secondary hover:text-aurocle-gold transition-colors">
            Return to Aurocle Agents
          </a>
        </div>
      </div>
    </div>
  );
}
